import {Injectable, Type} from '@angular/core';
import {CommunicationCenterService} from '@modules/communication-center';
import {ContextualService} from '@modules/assignation/core/services/contextual.service';
import {AssignationConfigurationService} from '@modules/assignation/core/services/assignation-configuration.service';

export async function loadAssignationComponent(componentName: 'AssignationComponent' | 'AssignmentByStepsComponent') {
    if (componentName === 'AssignationComponent') {
        const module = await import('@modules/assignation/core/components/assignation/assignation.component');
        return module.AssignationComponent;
    } else {
        const module = await import('@modules/assignation/core/components/assignment-by-steps/assignment-by-steps.component');
        return module.AssignmentByStepsComponent;
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssignmentComponentsService {
    private assignationComponentIsOpen = false;

    constructor(
        private contextualService: ContextualService,
        private communicationCenter: CommunicationCenterService,
        private assignationConfigurationService: AssignationConfigurationService,
    ) {
        // On passe une fonction qui retourne la promesse du composant
        this.communicationCenter
            .getRoom('assignment')
            .next('view', () => loadAssignationComponent(this.assignationConfigurationService.assignationModalComponentToUse() as any));

        this.contextualService.conditionAssignmentDialogOpen$
            .subscribe((callback) => callback(this.assignationComponentIsOpen));
    }

    public setAssignationComponentOpened(): void {
        this.assignationComponentIsOpen = true;
        this.updateContextual();
    }

    public setAssignationComponentClosed(): void {
        this.assignationComponentIsOpen = false;
        this.updateContextual();
    }

    private updateContextual(): void {
        this.contextualService.onConditionUpdate();
    }
}